<template>
  <div>
    <v-alert
      :value="showScore"
      type="success"
      transition="slide-y-reverse-transition"
    >
      You earned {{finalScore.totalEarnedPoints}} out of {{totalPossible}} total points
    </v-alert>
    <v-alert
      :value="showTheEnd"
      type="info"
      transition="slide-y-reverse-transition"
    >
      Game Over...
    </v-alert>
  </div>

</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "FinalResults",
  data() {
    return {
      showScore: false,
      showTheEnd: false
    };
  },
  methods: {},
  computed: {
    ...mapState("client", {
      finalScore: state => state.game.revealedScore
    }),
    ...mapGetters("client", {
      totalPossible: "getTotalPossiblePoints"
    })
  },
  created() {
    setTimeout(() => {
      this.showScore = true;
      setTimeout(() => {
        this.showTheEnd = true;
      }, 2000);
      
    }, 1000);
  }
};
</script>